<template>
  <code
    class="inline-flex items-center rounded-md bg-green-50 px-2.5 py-1 font-mono text-sm font-medium text-green-700 ring-1 ring-inset ring-green-200"
  >
    {{ label }}: {{ displayValue }}
  </code>
</template>

<script setup>
import { computed } from 'vue';

const props = defineProps({
  label: {
    type: String,
    required: true,
  },
  value: {
    type: [String, Number],
    default: null,
  },
  emptyLabel: {
    type: String,
    default: '—',
  },
});

const displayValue = computed(() => {
  if (props.value == null || props.value === '') {
    return props.emptyLabel;
  }

  return props.value;
});
</script>
